import MainTopView from "../../components/MainTopView/MainTopView";
const ConnectView = () => {
  document.title = "Prakash | Connect";
  return <MainTopView />;
};
export default ConnectView;
